import { QuestionSaleTypeForPlan } from "@/components/features/items/edit/_shared/ui/components/main/questions/sale-type-for-plan";

import { useRoomSaleTypeForPlan } from "./hooks";

export const QuestionRoomSaleTypeForPlan = () => {
	const { saleTypeForPlan, onSetSaleTypeForPlan, saleTypeForPlanOptions } = useRoomSaleTypeForPlan();

	return (
		<QuestionSaleTypeForPlan
			saleTypeForPlan={saleTypeForPlan}
			onSetSaleTypeForPlan={onSetSaleTypeForPlan}
			saleTypeForPlanOptions={saleTypeForPlanOptions}
		/>
	);
};

QuestionRoomSaleTypeForPlan.displayName = "QuestionRoomSaleTypeForPlan";
